// src/ui/design.ts
import type { Notification as OrderNotif } from '../types/Notification';

// Метаданные для <Tag>
export const statusDesign: Record<
  OrderNotif['status'],
  { color: string; style?: React.CSSProperties }
> = {
  new:        { color: 'red',     style: { fontSize: 14, fontWeight: 600 } },
  processing: { color: 'gold',    style: { fontSize: 14, fontWeight: 600 } },
  ready:      { color: 'blue',    style: { fontSize: 14, fontWeight: 600 } },
  shipped:    { color: 'cyan',    style: { fontSize: 14, fontWeight: 600 } },
  canceled:   { color: 'volcano', style: { fontSize: 14, fontWeight: 600 } },
  returned:   { color: 'purple',  style: { fontSize: 14, fontWeight: 600 } },
};

// Метаданные для «чипов» (фон/текст/подпись)
export const statusPalette: Record<
  OrderNotif['status'],
  { fg: string; bg: string; label: string }
> = {
  new:        { fg: '#ff4d4f', bg: '#fff1f0', label: 'Новые' },
  processing: { fg: '#faad14', bg: '#fffbe6', label: 'В работе' },
  ready:      { fg: '#1677ff', bg: '#e6f4ff', label: 'Готовы' },
  shipped:    { fg: '#13c2c2', bg: '#e6fffb', label: 'Продано' },
  canceled:   { fg: '#fa541c', bg: '#fff2e8', label: 'Отменены' },
  returned:   { fg: '#722ed1', bg: '#f9f0ff', label: 'Возвраты' },
};

// Тип товара
export type ItemType = 'original' | 'copy';
export const typeDesign: Record<ItemType, { color: string; style?: React.CSSProperties; label: string }> = {
  original: { color: 'green',   style: { fontSize: 14, fontWeight: 600 }, label: 'оригинал' },
  copy:     { color: 'default', style: { fontSize: 14, fontWeight: 600 }, label: 'копия' },
};

// ✅ Единый безопасный геттер: всегда возвращает корректные поля
export function getStatusMeta(raw?: OrderNotif['status'] | string | null) {
  const key = (raw ?? '').toString().trim().toLowerCase() as OrderNotif['status'];

  const tag =
    (statusDesign as Record<string, { color: string; style?: React.CSSProperties }>)[key] ??
    { color: 'default', style: { fontSize: 14, fontWeight: 600 } };

  const chip =
    (statusPalette as Record<string, { fg: string; bg: string; label: string }>)[key] ??
    { fg: '#595959', bg: '#f5f5f5', label: '—' }; // можно вернуть raw, если хочешь показывать исходный текст

  return { tag, chip };
}

// Алиас для совместимости со старым кодом
export const getStatusTag = getStatusMeta;

